module.exports = __webpack_public_path__ + "img/6.02fa3123.png";